export function setupControls() {
    const keysPressed = {};

    window.addEventListener('keydown', (event) => {
        keysPressed[event.key.toLowerCase()] = true;
    });
    window.addEventListener('keyup', (event) => {
        keysPressed[event.key.toLowerCase()] = false;
    });

    window.addEventListener('mousedown', (event) => {
        if (event.button === 0) keysPressed['shoot'] = true;
    });
    window.addEventListener('mouseup', (event) => {
        if (event.button === 0) keysPressed['shoot'] = false;
    });

    return { keysPressed };
}